export const PROTECTED_ROUTES = [
  '/user/',
  '/corretor/',
  '/tmplus/',
  '/ajudante-ia-dever-casa/'
]

export const NO_REGISTER_ROUTES = [
  '/corretor/',
  '/ajudante-ia-dever-casa/'
]

export const isProtectedRoute = (pathname: string) => {
  return PROTECTED_ROUTES.some(route => pathname.includes(route))
}

export const NO_NEED_RELOAD_ROUTES = [
  'corretor-de-redacao/',
  'ajudante-ia-dever-casa'
]

export const doesNotNeedReloadRoute = (pathname: string) => {
  return NO_NEED_RELOAD_ROUTES.some(route => pathname.includes(route))
}

export const doesNotNeedRegisterRoute = (pathname: string) => {
  return NO_REGISTER_ROUTES.some(route => pathname.includes(route))
}